// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"364":"42463095","462":"bbcd4a5a","569":"bbcd4a5a","954":"bbcd4a5a"}[chunkId] + ".chunk.css";
};